(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/game-guide/assets/javascripts/start-page.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/game-guide/assets/javascripts/start-page.js');
"use strict";

const {
  cdn
} = svs.core.config.data.svsconfig;
const urlMapping = svs.core.urlMapping;
const StartPage = () => React.createElement("div", {
  className: "game-guide-start-page"
}, React.createElement("h2", {
  className: "game-guide-start-page__heading"
}, "Oddset \xE4r f\xF6r dig som vill s\xE4tta din kunskap p\xE5 spel. Spela p\xE5 allt som kan h\xE4nda - och lite till!"), React.createElement("p", {
  className: "game-guide-start-page__paragraph"
}, "Vem vinner? Vem g\xF6r m\xE5l? Hur m\xE5nga m\xE5l blir det? Spela p\xE5 allt fr\xE5n fotboll och hockey till Melodifestivalen och e-sport."), React.createElement("img", {
  alt: "Favoriter, Fotboll, Travsport, Ishockey, Tennis, Basket, Am. Fotboll, E-sport, Underh\xE5llning",
  className: "margin-bottom-3 margin-top-3 game-guide-start-page__image",
  src: "".concat(cdn, "/images/oddset-kambi/components/game-guide/spelguideoddset1.svg")
}), React.createElement("p", {
  className: "game-guide-start-page__paragraph"
}, "V\xE4lj bland hundratals spelalternativ."), React.createElement("img", {
  alt: "Fulltid, Halvlekar, \xD6ver/Under, M\xE5lskytt, Skott p\xE5 m\xE5l, H\xF6rnor",
  className: "margin-bottom-3 margin-top-3 game-guide-start-page__image",
  src: "".concat(cdn, "/images/oddset-kambi/components/game-guide/spelguideoddset2.svg?cachebreak=1")
}), React.createElement("p", {
  className: "game-guide-start-page__paragraph"
}, "Bygg egna spelkombinationer med Bet Builder och maxa sp\xE4nningen."), React.createElement("img", {
  alt: "Bet Builder",
  className: "margin-bottom-3 margin-top-3 game-guide-start-page__image",
  src: "".concat(cdn, "/images/oddset-kambi/components/game-guide/spelguideoddset3.svg?cachebreak=1")
}), React.createElement("p", {
  className: "game-guide-start-page__paragraph"
}, "Vill du f\xE5 ut \xE4nnu mer av ditt spelande? Klicka p\xE5 de andra flikarna i guiden f\xF6r att ta del av tips om funktioner som kan f\xF6rh\xF6ja din spelupplevelse ytterligare."), React.createElement("p", {
  className: "game-guide-start-page__subheading"
}, "Mer information om Oddset"), React.createElement("strong", null, "Spelregler"), React.createElement("a", {
  href: urlMapping.get('termsIntegrityRules')
}, "L\xE4s mer om spelreglerna f\xF6r alla v\xE5ra spel"), React.createElement("br", null), React.createElement("strong", null, "Hantering av personuppgifter"), React.createElement("a", {
  href: urlMapping.get('termsIntegrityPersonData')
}, "L\xE4s mer om hur vi och v\xE5r samarbetspartner Kambi behandlar personuppgifter"), React.createElement("br", null), React.createElement("strong", null, "Villkor"), React.createElement("a", {
  href: urlMapping.get('termsIntegrityTerms')
}, "L\xE4s mer om v\xE5ra villkor"));
setGlobal('svs.oddset_kambi.components.game_guide.StartPage', StartPage);

 })(window);